export default __webpack_public_path__ + "static/media/upload-image.e450bae8.svg";